export enum renderComponentEnum {
    metrics = "metrics",
    dataGrid = "dataGrid",
    nurturingHistory = "nurturingHistory",
    nurturingHistoryNoSql = "nurturingHistoryNoSql"
}

export enum dataGridTypeEnum {
    leads = "leads",
    segments = "segments",
}

export enum metricTypeEnum {
    opportunityAdded = "TOTAL_PROSPECTS",
    opportunityAddedInNurturing = "UNDER_NURTURING",
    availableForNurturing = "AVAILABLE",
    segment = "SEGMENT",
    engagement = "ENGAGEMENT",
    leadUnsubscribed = "LEAD_UNSUBSCRIBED",
    leadContacted = "LEAD_CONTACTED",
    leadSold = "LEAD_SOLD",
}

export enum columnEnum {
    leadContacted = "LEAD_CONTACTED",
    leadSold = "LEAD_SOLD",
    leadDetails = "lead_details_in_a_string",
    buyer = "name"
}

export enum nurturingStatusEnum {
    contacted = "CONTACTED",
    sold = "SOLD",
    underNurturing = "UNDER_NURTURING"
}

export enum metricTitleEnum {
    opportunityAdded = "Unique Opportunities",
    opportunityAddedInNurturing = "Under Nurturing",
    availableForNurturing = "Available for Nurturing",
    segment = "Segments",
    engagement = "Engagement Rate",
    leadUnsubscribed = "Unsubscribe Rate",
    leadContacted = "Cold Leads Revived",
    leadSold = "Influenced Sales",
}

export enum metricIconEnum {
    OPPORTUNITY_ADDED = '👥',
    OPPORTUNITY_ADDED_IN_NURTURING = '👥',
    AVAILABLE_FOR_NURTURING = '📥',
    SEGMENT = '🔍',
    ENGAGEMENT = '💬',
    LEAD_UNSUBSCRIBED = '📧',
    LEAD_CONTACTED = '🔄',
    LEAD_SOLD = '📈',
}

export enum papeTitleEnum {
    default = "Opportunites",
}

// export enum timePeriodEnum {
//     lastMonth = "LAST_MONTH",
//     threeMonths = "LAST_3_MONTHS",
//     sixMonths = "SIX_MONTHS",
//     oneYear = "ONE_YEAR"
// }

export enum timePeriodEnum {
    ALL_TIME = "ALL_TIME",
    TODAY = "TODAY",
    YESTERDAY = "YESTERDAY",
    THIS_WEEK = "THIS_WEEK",
    LAST_WEEK = "LAST_WEEK",
    WEEK_TO_DATE = "WEEK_TO_DATE",
    THIS_MONTH = "THIS_MONTH",
    LAST_MONTH = "LAST_MONTH",
    MONTH_TO_DATE = "MONTH_TO_DATE",
    THIS_QUARTER = "THIS_QUARTER",
    LAST_QUARTER = "LAST_QUARTER",
    QUARTER_TO_DATE = "QUARTER_TO_DATE",
    THIS_YEAR = "THIS_YEAR",
    LAST_YEAR = "LAST_YEAR",
    YEAR_TO_DATE = "YEAR_TO_DATE",
    SINCE = "SINCE",
    LAST = "LAST",
    SIX_MONTHS = "SIX_MONTHS",
}

export enum nurturingHistoryCardTitleEnum {
    original = "Original",
    sold = "Sold",
    contacted = "Revived"
}
